import { STATEMENT_KINDS } from "./statementKinds";

// Asks the coaching service which of the user's goals a statement connects to. Resolves to goal ids,
// best match first; an empty list when nothing fits.
export async function suggestGoals(kind, text, goals) {
  const res = await fetch("/api/chat", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-sonnet-4-6",
      max_tokens: 200,
      messages: [{ role: "user", content: `Given this ${STATEMENT_KINDS[kind].suggestAs}: "${text}"\nAnd these goals: ${JSON.stringify(goals.map(g => g.title))}\nReturn a JSON array of goal titles most likely connected to it, ordered by confidence.\nResponse format: ["goal title 1", "goal title 2"]\nOnly include goals with a genuine thematic connection. Maximum 5 suggestions.` }],
    }),
  });
  const data = await res.json();
  const raw = data.content?.[0]?.text?.trim() || "[]";
  const titles = JSON.parse(raw.replace(/```json|```/g, "").trim());
  return goals.filter(g => titles.includes(g.title)).map(g => g.id);
}
